import type { ServiceType } from '../../../api/types';
import { svcLabel } from './constants';
import { inpSt, selSt } from './sharedStyles';

export function OptionsPanel({
  serviceType, options, onChange,
}: {
  serviceType: ServiceType;
  options: Record<string, unknown>;
  onChange: (opts: Record<string, unknown>) => void;
}) {
  const upd = (key: string, val: unknown) => onChange({ ...options, [key]: val });
  const f = (key: string, def = '') => (options[key] as string) ?? def;
  const n = (key: string) => options[key] != null ? String(options[key]) : '';

  const inp = (label: string, key: string, type = 'text', placeholder = '') => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
      <label style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-muted)', fontWeight: 500 }}>{label}</label>
      <input
        type={type} value={type === 'number' ? n(key) : f(key)} placeholder={placeholder}
        onChange={e => upd(key, type === 'number' ? (e.target.value ? Number(e.target.value) : '') : e.target.value)}
        style={inpSt}
      />
    </div>
  );

  const sel = (label: string, key: string, opts: string[]) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
      <label style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-muted)', fontWeight: 500 }}>{label}</label>
      <select value={f(key)} onChange={e => upd(key, e.target.value)} style={selSt}>
        <option value="">— scegli —</option>
        {opts.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );

  const panelMap: Partial<Record<ServiceType, React.ReactNode>> = {
    ALBUM: (
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
        {sel('Dimensione', 'dimension', ['20x20', '25x25', '30x30', '35x35', '40x40', 'Personalizzata'])}
        {inp('N. pagine', 'pages', 'number', 'es. 60')}
        {inp('Copertina', 'cover', 'text', 'es. Pelle nera')}
        {inp('Note', 'note', 'text', 'opzionale')}
      </div>
    ),
    DRONE: inp('Ore di volo', 'hours', 'number', 'es. 2'),
    VIDEO_MATRIMONIO: inp('Durata stimata (min)', 'durationMin', 'number', 'es. 25'),
    TRAILER: inp('Durata stimata (min)', 'durationMin', 'number', 'es. 4'),
  };

  const panel = panelMap[serviceType];
  if (!panel) return null;

  return (
    <div style={{ marginTop: '0.5rem', padding: '0.625rem 0.75rem', background: 'var(--glass-bg-card)', borderRadius: 'var(--radius-interactive)', border: '1px dashed rgba(255,255,255,0.10)' }}>
      <p style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-faint)', marginBottom: '0.5rem', fontWeight: 600 }}>
        Opzioni {svcLabel(serviceType)}
      </p>
      {panel}
    </div>
  );
}
